import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';

import './vehicle.css';

function VehicleType() {
  const [user, setUser] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      if (!user) {
        // User is not authenticated, redirect to the login page
        navigate('/');
      }
    });

    // Update the current time every second
    const intervalId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => {
      clearInterval(intervalId);
      unsubscribe(); // Cleanup the subscription when the component unmounts
    };
  }, [navigate, user]);

  const handleLogout = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
      console.log('User logged out successfully');
      // The onAuthStateChanged listener will redirect to the login page when the user is set to null
    } catch (error) {
      console.error('Error logging out:', error.message);
    }
  };

  // Function to format time to HH:MM:SS
  const formatTime = (time) => {
    const options = { hour: 'numeric', minute: 'numeric', second: 'numeric' };
    return new Intl.DateTimeFormat('en-US', options).format(time);
  };

  // Function to format date to Day, Month Date, Year
  const formatDate = (date) => {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return new Intl.DateTimeFormat('en-US', options).format(date);
  };

  return (
    <>
      <div className='vehicle-container'>
        <div className="hero-section">
          <h3 className='tgo'>Track N Go: Transforming Daily Commutes</h3>
          <p>Imagine a world where public transportation is predictable and efficient. With Track N Go, we make it a reality.</p>
        </div>
        <div className="top-left-info">
          <p className="time">{formatTime(currentTime)}</p>
          <p className="date">{formatDate(currentTime)}</p>
        </div>
        <div>
          <p className='welcome-message'>Welcome, {user?.displayName || 'User'}</p>
          <Link to="/profile">
            <button className="viewprofile">
              View Profile
            </button>
          </Link>
          <Link to="/feedback">
            <button className="user-feedback">
              User Feedback
            </button>
          </Link>
          <button className="vehicle-logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
        <p>Add/Modify/Delete your Vehicles Data by selecting the appropriate buttons below.</p>
        <div className="button-grid">
          {/* Buttons for Navigation */}
          <Link to="../bus">
            <button className="vehicle-button">Register Public Bus</button>
          </Link>
          <Link to="../Collegebus">
            <button className="vehicle-button">Register College/City Bus</button>
          </Link>
          <Link to="../DisplayCollegeBuses">
            <button className="vehicle-button">Display College/City Buses</button>
          </Link>
          <Link to="../DisplayVehicles">
            <button className="vehicle-button">Display Public Buses</button>
          </Link>
        </div>
        <div className="features-section" id="features">
          <div className="feature-card">
            <h3>Real-Time Tracking</h3>
            <p>Experience precise real-time tracking using mobile phone location data.</p>
          </div>
          <div className="feature-card">
            <h3>Cost-Effective Solution</h3>
            <p>Track N Go offers a cost-effective alternative to traditional IoT-based solutions.</p>
          </div>
        </div>
        <footer className="footer-section">
           Developed by:
      <div className="developer-info">
        <a href="https://www.linkedin.com/in/shaik-mohammed-naveed-9ba4a5212/" >Shaik Mohammed Naveed </a>
      </div>
      <div className="developer-info">
        <a href="https://www.linkedin.com/in/mahika-dhar/" > Mahika Dhar M </a>
      </div>
      <div className="developer-info">
        <a href="https://www.linkedin.com/in/suhail-ahmed-8a78b5200/" > Suhail Ahmed</a>
      </div>
      <div className="developer-info">
        <a href="https://www.linkedin.com/in/utkarsh-kumar-58a586200/">Utkarsh Kumar</a> </div>
    </footer>
          </div>
    </>
  );
}

export default VehicleType;
